import { Routes, Route } from "react-router-dom";
import AngularHost from "./AngularHost";
import ProtectedRoute from "./auth/ProtectedRoute";

import LoginPage from "./pages/login";
import Dashboard from "./pages/dashboard";
import EventRCA from "./pages/event-rca";
import MainLayout from "./layouts/mainLayout";
import Unauthorized from "./pages/unauthorized";
import TagMissing from "./pages/tag-missing";
import UnwantedBraking from "./pages/unwanted-braking";
import ReaderEfficiency from "./pages/reader-efficiency";
import CabRFIdReader from "./pages/cab-rfid-reader";
import SignalBlanking from "./pages/signal-blanking";
import RFIssuesStation from "./pages/rf-issues-station";
import RFIssuesLoco from "./pages/rf-issues-loco";
import CardDiagnostics from "./pages/card-diagnostics";
import CardStatus from "./pages/card-status";
import SpeedometerHealthMonitoring from "./pages/speedometer-health-monitoring";
import S2sLinkFailure from "./pages/s2s-link-failure";
import EigwFailure from "./pages/eigw-failure";
import BrakeVCLogsMonitoring from "./pages/brake-vc-logs-monitoring";
import DmiHealthMonitoring from "./pages/dmi-health-monitoring";
import FindTrips from "./pages/find-trips";
import CrashLogs from "./pages/crash-logs";
import ReactNavigationListener from "./auth/ReactNavigationListener";
import AngularLogoutListener from "./auth/AngularLogoutListener";
import TripWiseSummary from "./pages/trip-wise-summary";
import RadioParametersMonitoring from "./pages/radio-paramters-monitoring";
import ChecksumChangeReport from "./pages/checksum-change-report";
import { HBL_PA_RESOURCES } from "./constants/data.cnst";
import FIU from "./pages/fiu";
import SystemFailure from "./pages/system-failure";
import ChangeoverOfCards from "./pages/changeover-of-cards";
import RIU from "./pages/riu";
import SignalAspectBlanking from "./pages/signal-aspect-blanking";
import MyProfile from "./pages/my-profile";
import MonitoringBootLogs from "./pages/monitoring-boot-logs";
import StationMetadata from "./pages/station-metadata";
import StationEvents from "./pages/station-events";
import TagMissingNew from "./pages/tag-missing-new";
import LandingPage from "./pages/landingPage";
import StationEventRCA from "./pages/station-event-rca";
import LocoHealthNew from "./pages/loco-health-new";
import StationHealthNew from "./pages/station-health-new";
import UnifiedKPI from "./pages/unified-kpi";
import RadioHealth from "./pages/radio-health";

function App() {
  return (
    <>
      <AngularHost hidden />
      <ReactNavigationListener />
      <AngularLogoutListener />
      <Routes>

        {/* Angular Entry */}
        {/* <Route path="/" element={<AngularHost />} /> */}

        {/* React Protected */}
        <Route element={
          // <ProtectedRoute resource={HBL_PA_RESOURCES.EVENTS}>
          <MainLayout />}>
          {/* </ProtectedRoute>}> */}

          <Route path="/dashboard" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.LOCO_EVENTS}>
              <Dashboard />
            </ProtectedRoute>
          } />

          <Route path="/dashboard/station-events" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.STATION_EVENTS}>
              <StationEvents />
            </ProtectedRoute>
          } />

          <Route path="/my-profile" element={<MyProfile />} />

          <Route path="/usermgmt/*" element={<AngularHost />} />
          <Route path="/dashboard/event-rca" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.EVENTS}>
              <EventRCA />
            </ProtectedRoute>
          } />

          <Route path="/health/loco-health" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.LOCO_HEALTH}>
              <LocoHealthNew />
            </ProtectedRoute>
          } />

          <Route path="/health/station-health" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.STATION_HEALTH}>
              <StationHealthNew />
            </ProtectedRoute>
          } />

          <Route path="/health/radio-health" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.RADIO_HEALTH}>
              <RadioHealth />
            </ProtectedRoute>
          } />

          <Route path="/find-trips" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.TRIP_SUMMARY}>
              <FindTrips />
            </ProtectedRoute>
          } />

          <Route path="/find-trips/trip-wise-summary" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.TRIP_SUMMARY}>
              <TripWiseSummary />
            </ProtectedRoute>
          } />

          <Route path="/report/events/tag-missing" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.EVENTS_TAG_MISSING}>
              <TagMissing />
            </ProtectedRoute>
          } />

          <Route path="/report/events/tag-new" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.EVENTS_TAG_MISSING_NEW}>
              <TagMissingNew />
            </ProtectedRoute>
          } />

          <Route path="/report/events/unwanted-braking" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.EVENTS_UNWANTED_BRAKING}>
              <UnwantedBraking />
            </ProtectedRoute>
          } />

          <Route path="/report/loco-health/cab-rfid-reader" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.LOCO_CAB_RFID_READER}>
              <CabRFIdReader />
            </ProtectedRoute>
          } />

          <Route path="/report/events/signal-blanking" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.EVENTS_SIGNAL_BLANKING}>
              <SignalBlanking />
            </ProtectedRoute>
          } />


          <Route path="/report/loco-health/reader-efficiency" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.LOCO_READER_EFFICIENCY}>
              <ReaderEfficiency />
            </ProtectedRoute>
          } />

          <Route path="/report/station-health/rf-issues-station" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.STATION_RF_ISSUES}>
              <RFIssuesStation />
            </ProtectedRoute>
          } />

          <Route path="/report/station-health/fiu" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.STATION_FIU}>
              <FIU />
            </ProtectedRoute>
          } />

          <Route path="/report/station-health/riu" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.STATION_RIU}>
              <RIU />
            </ProtectedRoute>
          } />

          <Route path="/report/station-health/signal-aspect-blanking" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.STATION_SIGNAL_ASPECT_BLANKING}>
              <SignalAspectBlanking />
            </ProtectedRoute>
          } />

          <Route path="/report/station-health/card-status" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.STATION_CARD_STATUS}>
              <CardStatus />
            </ProtectedRoute>
          } />

          <Route path="/report/station-health/card-diagnostics" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.STATION_CARD_DIAGNOSTICS}>
              <CardDiagnostics />
            </ProtectedRoute>
          } />

          <Route path="/report/station-health/crash-logs" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.STATION_CRASH_LOGS}>
              <CrashLogs />
            </ProtectedRoute>
          } />

          <Route path="/report/station-health/radio-parameters-monitoring" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.STATION_RADIO_PARAMETERS_MONITORING}>
              <RadioParametersMonitoring />
            </ProtectedRoute>
          } />

          <Route path="/report/station-health/checksum-change-report" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.STATION_CHECKSUM_CHANGE}>
              <ChecksumChangeReport />
            </ProtectedRoute>
          } />

          <Route path="/report/loco-health/rf-issues-loco" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.LOCO_RF_ISSUES}>
              <RFIssuesLoco />
            </ProtectedRoute>
          } />

          <Route path="/report/loco-health/crash-logs" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.LOCO_CRASH_LOGS}>
              <CrashLogs />
            </ProtectedRoute>
          } />

          <Route path="/report/loco-health/card-status" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.LOCO_CARD_STATUS}>
              <CardStatus />
            </ProtectedRoute>
          } />

          <Route path="/report/loco-health/radio-parameters-monitoring" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.LOCO_RADIO_PARAMETERS_MONITORING}>
              <RadioParametersMonitoring />
            </ProtectedRoute>
          } />

          <Route path="/report/loco-health/checksum-change-report" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.LOCO_CHECKSUM_CHANGE}>
              <ChecksumChangeReport />
            </ProtectedRoute>
          } />

          <Route path="/report/loco-health/card-diagnostics" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.LOCO_CARD_DIAGNOSTICS}>
              <CardDiagnostics />
            </ProtectedRoute>
          } />

          <Route path="/report/loco-health/dmi-health-monitoring" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.LOCO_DMI_HEALTH_MONITORING}>
              <DmiHealthMonitoring />
            </ProtectedRoute>
          } />

          <Route path="/report/loco-health/speedometer-health-monitoring" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.LOCO_SPEEDOMETER_HEALTH_MONITORING}>
              <SpeedometerHealthMonitoring />
            </ProtectedRoute>
          } />

          <Route path="/report/station-health/s2s-link-failure" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.STATION_S2S_LINK_FAILURE}>
              <S2sLinkFailure />
            </ProtectedRoute>
          } />

          <Route path="/report/station-health/changeover-of-cards" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.STATION_CHANGEOVER_OF_CARDS}>
              <ChangeoverOfCards />
            </ProtectedRoute>
          } />

          <Route path="/report/station-health/system-failure" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.STATION_SYSTEM_FAILURE}>
              <SystemFailure />
            </ProtectedRoute>
          } />

          <Route path="/report/station-health/eigw-failure" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.STATION_EIGW_FAILURE}>
              <EigwFailure />
            </ProtectedRoute>
          } />

          <Route path="/report/station-health/monitoring-boot-logs" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.STATION_MONITORING_BOOT_LOGS}>
              <MonitoringBootLogs />
            </ProtectedRoute>
          } />

          <Route path="/report/loco-health/brake-failure" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.LOCO_BRAKE_VC_LOGS_MONITORING}>
              <BrakeVCLogsMonitoring />
            </ProtectedRoute>
          } />

          <Route path="/station-metadata" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.STATION_METADATA}>
              <StationMetadata />
            </ProtectedRoute>
          } />

          <Route path="/dashboard/station-events-rca" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.STATION_EVENTS}>
              <StationEventRCA />
            </ProtectedRoute>
          } />

          <Route path="/unified-kpi" element={
            <ProtectedRoute resource={HBL_PA_RESOURCES.UNIFIED_KPI}>
              <UnifiedKPI />
            </ProtectedRoute>
          } />

        </Route>

        <Route path="/login" element={<LoginPage />} />
        <Route path="/unauthorized" element={<Unauthorized />} />

        <Route path="/" element={<LandingPage />} />

        <Route path="*" element={<LandingPage />} />

      </Routes>
    </>
  );
}

export default App;
